module.exports = __webpack_public_path__ + "img/starry-night-display.52aa0f67.png";